import React from 'react';
import { Routes, Route, Navigate, useLocation, Link } from 'react-router-dom';
import MarketData from './MarketData';
import Search from './Search';
import FinancialData from './FinancialData';
import RegulatoryData from './RegulatoryData';
import Tags from './Tags';

const Intel = () => {
  const location = useLocation();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Intel Dashboard</h1>

      {/* Intel Navigation */}
      <div className="mb-8 border-b border-gray-200">
        <nav className="flex space-x-4 overflow-x-auto pb-2">
          <Link
            to="/intel/market"
            className={`px-3 py-2 rounded-t-lg font-medium ${
              location.pathname.startsWith('/intel/market')
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
            }`}
          >
            Market Data
          </Link>
          <Link
            to="/intel/search"
            className={`px-3 py-2 rounded-t-lg font-medium ${
              location.pathname.startsWith('/intel/search')
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
            }`}
          >
            Search
          </Link>
          <Link
            to="/intel/financial"
            className={`px-3 py-2 rounded-t-lg font-medium ${
              location.pathname.startsWith('/intel/financial')
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
            }`}
          >
            Financial Data
          </Link>
          <Link
            to="/intel/regulatory"
            className={`px-3 py-2 rounded-t-lg font-medium ${
              location.pathname.startsWith('/intel/regulatory')
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
            }`}
          >
            Regulatory Data
          </Link>
          <Link
            to="/intel/tags"
            className={`px-3 py-2 rounded-t-lg font-medium ${
              location.pathname.startsWith('/intel/tags')
                ? 'bg-blue-600 text-white'
                : 'text-gray-600 hover:text-gray-800 hover:bg-gray-100'
            }`}
          >
            Tags
          </Link>
        </nav>
      </div>

      {/* Intel Routes */}
      <Routes>
        <Route path="market/*" element={<MarketData />} />
        <Route path="search/*" element={<Search />} />
        <Route path="financial/*" element={<FinancialData />} />
        <Route path="regulatory/*" element={<RegulatoryData />} />
        <Route path="tags/*" element={<Tags />} />
        <Route path="*" element={<Navigate to="/intel/market" replace />} />
      </Routes>
    </div>
  );
};

export default Intel;
